module.exports = __webpack_public_path__ + "img/cf144e1.png";